<template>
  <div>
    <div
      class="flex justify-center">
      <div class="text-center greet-user" style="max-width: 450px">
        <img
          src="@/assets/img/waiting-list/queue-ilustration.svg"
          alt="Waiting List"
          width="auto"
          height="120">
        <h1 class="mt-5">
          {{ $t('Title') }}
        </h1>

        <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto my-5">
          {{ $t('Description') }}
        </p>

        <a
          href="#"
          class="link-cta"
          @click.prevent="$emit('setup')">
          {{ $t('SetupNowButtonText') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WaitingListNotConfigured',
  i18n: {
    messages: {
      en: {
        Title: 'Boost your business with smart queue management',
        Description: 'Let people join your queue with a QR code, and we’ll handle the rest—confirmations, turn alerts, follow-ups, and more.',
        SetupNowButtonText: 'Set up now',
      },
    },
  },
};
</script>

<style scoped lang="scss">

</style>
